<template>
  <vue-modal
    v-model="value"
    @close="$emit('update:modelValue', false)"
  >
    <div class="modal-content +clip">
      <iframe
        class="w-screen h-[56vw] lg:w-[640px] lg:h-[360px]"
        :src="src"
        title="YouTube Video Player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
  </vue-modal>
</template>

<script setup>
import { ref, computed } from 'vue'
const props = defineProps({
  modelValue: Boolean,
  videoId: {
    type: String,
    required: true
  }
})
defineEmits([ 'update:modelValue' ])
const src = ref(`https://www.youtube.com/embed/${props.videoId}?autoplay=1`)
const value = computed(() => props.modelValue)
</script>
